export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-w.82b3616b.webp";